import React from 'react'

import IntroLayout from '../layouts/Intro.jsx'

const Intro = (props) => {
  return <IntroLayout title={props?.data?.section_1?.title ?? ''} />
}

export default Intro
